import { useDetectKeyboardOpen } from 'hooks/useDetectKeyboardOpen'

import { cn } from 'utils/cn'

import type { FC, PropsWithChildren } from 'react'

export const MainContentWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { isKeyboardOpen } = useDetectKeyboardOpen()

  return (
    <div id="main-content" className="mx-auto mt-14 w-full lg:mt-16 print:mt-0">
      <div className={cn('flex flex-col w-full justify-center print:pb-0', {
        'pb-44 lg:pb-40': isKeyboardOpen,
      })}
      >
        {children}
      </div>
    </div>
  )
}
